import { render, staticRenderFns } from "./ModalDomicilio.vue?vue&type=template&id=74169b68"
import script from "./ModalDomicilio.vue?vue&type=script&lang=js"
export * from "./ModalDomicilio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74169b68')) {
      api.createRecord('74169b68', component.options)
    } else {
      api.reload('74169b68', component.options)
    }
    module.hot.accept("./ModalDomicilio.vue?vue&type=template&id=74169b68", function () {
      api.rerender('74169b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/ModalDomicilio.vue"
export default component.exports